import React, { useState, useEffect, FC } from 'react';
import { Grid } from 'semantic-ui-react';
import SellStake from '../components/SellStake';
import NoWalletConnected from '../components/NoWalletConnected';
import { provider, userSocialVault } from '../ethereum/web3';

interface ISellProps {
  vaults?: [];
}

const Sell:FC<ISellProps> = (props: ISellProps) => {
  const [isConnected, setIsConnected] = useState<boolean>((window as any).ethereum !== undefined);
  const [vaults, setVaults] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(true);

  async function getAccounts() {
    if ((window as any).ethereum) {
      const accounts = await provider.listAccounts();
      setIsConnected(accounts.length > 0);
    }
  }

  async function getUserVaults() {
    try {
      setLoading(true);
      const userVaultIds = await userSocialVault.getAllUserVaults();
      const vaults = await Promise.all(
          userVaultIds.map((element: any) => {
              return userSocialVault.getVaultDetailsForUser(element);
          })
      );
      setVaults(vaults);
    } catch (e) {
      console.log((e as Error).message);
    }
    setLoading(false);
  }

  function renderVaults(vaults: any) {
    if (vaults.length === 0) {
      return (<h1>Nothing to sell</h1>);
    }

    const vaultComponents = vaults.map((vault: any) => {
      return <SellStake
        key={vault[0]}
        address={vault[0]}
        name={vault[1]}
        stakedAmount={vault[2].toString()}
        targetAmount={vault[3].toString()}
        isSelling={vault[4]}
        url={vault[5]}
      />
    });

    return vaultComponents;
  }

  useEffect(() => {
    getAccounts();
    if (isConnected) {
      getUserVaults();
    }
  }, [setIsConnected, isConnected]);
  return(
    <Grid columns='equal'>
      <Grid.Column width={1}>
        <div className="outer">
          <div className="inner rotate">SELL&nbsp;STAKE</div>
        </div>
      </Grid.Column>
      <Grid.Column>
        <div className="App-header">
        { !isConnected ?
            <NoWalletConnected />
          :
              loading ? 'Loading...' : renderVaults(vaults)
        }
        </div>
      </Grid.Column>
      <Grid.Column width={1} />
    </Grid>
  )
}

export { Sell };
